import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  isAuthenticated: false,
  loading: true, // Start with loading true to wait for initial auth check
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginRequest(state) {
      state.loading = true;
      state.error = null;
    },
    loginSuccess(state, action) {
      state.loading = false;
      state.isAuthenticated = true;
      state.user = action.payload;
      state.error = null;
    },
    loginFailure(state, action) {
      state.loading = false;
      state.isAuthenticated = false;
      state.error = action.payload || 'Login failed';
    },
    registerRequest(state) {
      state.loading = true;
      state.error = null;
    },
    registerSuccess(state, action) {
      state.loading = false;
      state.user = action.payload;
      state.error = null;
    },
    registerFailure(state, action) {
      state.loading = false;
      state.error = action.payload || 'Registration failed';
    },
    logout(state) {
      state.user = null;
      state.isAuthenticated = false;
      state.loading = false;
      state.error = null;
    },
    clearError(state) {
      state.error = null;
    },
    restoreAuth(state, action) {
      state.user = action.payload.user;
      state.isAuthenticated = action.payload.isAuthenticated;
      state.loading = false;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    checkAuth(state) {
      state.loading = true;
    },
    refreshTokenRequest(state) {
    },
    refreshTokenSuccess(state) {
      // Token refreshed silently, do nothing to the UI
      state.error = null;
    },
    refreshTokenFailure(state) {
      // If the refresh token is also expired, force a logout
      state.isAuthenticated = false;
      state.user = null;
      state.error = 'Session expired. Please log in again.';
    }
  },
});

export const {
  loginRequest,
  loginSuccess,
  loginFailure,
  registerRequest,
  registerSuccess,
  registerFailure,
  logout,
  clearError,
  restoreAuth,
  setLoading,
  checkAuth,
  refreshTokenRequest, 
  refreshTokenSuccess, 
  refreshTokenFailure,
} = authSlice.actions;

export default authSlice.reducer;

